document.addEventListener('click', function(event) {
  const filter = event.target.closest('[data-mtm-filter]');
  if (!filter) return;
  const root = filter.closest('[data-mtm-catalogue-library]');
  root.querySelectorAll('[data-mtm-filter]').forEach(button => button.classList.toggle('active', button === filter));
  const category = filter.dataset.mtmFilter;
  let count = 0;
  root.querySelectorAll('.catalog-card').forEach(card => {
    const show = category === 'All' || card.dataset.category === category;
    card.hidden = !show;
    if (show) count++;
  });
  root.querySelector('[data-mtm-count]').textContent = count + (count === 1 ? ' catalogue' : ' catalogues');
  root.querySelector('.catalog-empty').hidden = count !== 0;
});

(() => {
  const panel = document.querySelector('.location-panel');
  if (!panel) return;
  const tabs = [...panel.querySelectorAll('[role="tab"]')];
  const places = [
    { type: 'Hong Kong office', name: 'MTM Technology Limited', lines: ['820 Ocean Centre','5 Canton Road','Tsim Sha Tsui, Kowloon','Hong Kong'], query: 'Ocean Centre, 5 Canton Road, Tsim Sha Tsui, Hong Kong' },
    { type: 'Manufacturing plant', name: 'MTM Industrial Limited', lines: ['98 Dingwan 4th Road','Sanzao Town, Jinwan District','Zhuhai City, Guangdong','China'], query: '98 Dingwan 4th Road, Sanzao Town, Jinwan District, Zhuhai, Guangdong, China' }
  ];
  let selected = 0;
  const copy = panel.querySelector('button.location-secondary');
  const amap = document.createElement('a');
  amap.className = 'location-secondary';
  amap.href = 'https://uri.amap.com/search?keyword=' + encodeURIComponent('珠海市金湾区三灶镇定湾四路98号') + '&view=map&callnative=1';
  amap.target = '_blank';
  amap.rel = 'noopener noreferrer';
  amap.textContent = 'Open in Amap ↗';
  amap.hidden = true;
  copy.before(amap);
  const select = index => {
    selected = index;
    const place = places[index];
    tabs.forEach((tab, i) => {
      tab.classList.toggle('active', i === index);
      tab.setAttribute('aria-selected', String(i === index));
      tab.tabIndex = i === index ? 0 : -1;
    });
    panel.querySelector('.location-type').textContent = place.type;
    panel.querySelector('h3').textContent = place.name;
    panel.querySelector('.location-address').replaceChildren(...place.lines.map(line => {
      const span = document.createElement('span');
      span.textContent = line;
      return span;
    }));
    const map = panel.querySelector('iframe');
    map.src = 'https://www.google.com/maps?q=' + encodeURIComponent(place.query) + '&output=embed';
    map.title = place.name + ' map';
    map.setAttribute('aria-label', 'Map showing ' + place.name);
    panel.querySelector('.location-directions').href = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(place.query);
    amap.hidden = index !== 1;
    copy.textContent = 'Copy address';
  };
  tabs.forEach((tab, i) => {
    tab.tabIndex = i === 0 ? 0 : -1;
    tab.addEventListener('click', () => select(i));
    tab.addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      select(next);
      tabs[next].focus();
    });
  });
  copy.setAttribute('aria-live', 'polite');
  copy.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(places[selected].lines.join('\n'));
      copy.textContent = 'Address copied';
    } catch {
      copy.textContent = 'Select the address to copy';
      const range = document.createRange();
      range.selectNodeContents(panel.querySelector('.location-address'));
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    }
  });
})();
